import React from "react"

import {FieldViewGroupProps} from "../../../../render/group/@type"
import {ColorPalette} from "../../../../color-coding/color-coding";

// const debug = "FieldDropdown_ViewGroup"
const debug = false

export default function FieldDropdown_ViewGroup(props: FieldViewGroupProps) {

    const value     = props.field.getViewValue(props.model)
    const option    = props.field._getOption(value)

    debug && console.log(debug, 'render', value, option)

    const classes       = Classes("flex-row-left-center ui5-txt-less-important ui5-txt-bold", props.className)
    const iconClasses   = Classes('ui5-ico-13', props.field.icon, {
        // ['gd-c-font-{0}'.f(option.color)]: option.color
    })

    const iconStyle = {
        color: option.color ? gd.skin.colors.mainColor({
            colorNumber: option.color,
            corePalette: ColorPalette.CORE
        }) : undefined
    }

    return (
        <div className={classes}>
            {props.showGroupIcon !== false &&
                <div className="flex-row-center-center flex-no-shrink size-22">
                    <div className={iconClasses} style={iconStyle}/>
                </div>
            }
            <div className="max-w-100-percent txt-truncate view-group-label">
                {props.field.groupLabel(value, props.groupBy)}
            </div>
        </div>
    )
}



